// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file common/bonus.proto (package common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/bonus.proto.
 */
export const file_common_bonus: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message common.BonusRulesMessage
 */
export type BonusRulesMessage = Message<"common.BonusRulesMessage"> & {
  /**
   * @generated from field: string wagering_multiplier = 1;
   */
  wageringMultiplier: string;

  /**
   * @generated from field: common.WageringScope wagering_scope = 2;
   */
  wageringScope: WageringScope;

  /**
   * @generated from field: optional string min_trade = 3;
   */
  minTrade?: string;

  /**
   * @generated from field: optional string max_trade = 4;
   */
  maxTrade?: string;

  /**
   * @generated from field: optional string max_win = 5;
   */
  maxWin?: string;
};

/**
 * Describes the message common.BonusRulesMessage.
 * Use `create(BonusRulesMessageSchema)` to create a new message.
 */
export const BonusRulesMessageSchema: GenMessage<BonusRulesMessage> = /*@__PURE__*/
  messageDesc(file_common_bonus, 0);

/**
 * @generated from message common.BonusMessage
 */
export type BonusMessage = Message<"common.BonusMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: common.BonusStatus status = 2;
   */
  status: BonusStatus;

  /**
   * @generated from field: optional string code = 3;
   */
  code?: string;

  /**
   * @generated from field: string bonus_balance = 4;
   */
  bonusBalance: string;

  /**
   * @generated from field: string current_turnover = 5;
   */
  currentTurnover: string;

  /**
   * @generated from field: string required_turnover = 6;
   */
  requiredTurnover: string;

  /**
   * @generated from field: string remaining_turnover = 7;
   */
  remainingTurnover: string;

  /**
   * @generated from field: string progress_percent = 8;
   */
  progressPercent: string;

  /**
   * @generated from field: optional string activated_at = 9;
   */
  activatedAt?: string;

  /**
   * @generated from field: optional string expires_at = 10;
   */
  expiresAt?: string;

  /**
   * @generated from field: optional int32 time_left_seconds = 11;
   */
  timeLeftSeconds?: number;

  /**
   * @generated from field: optional string cancel_reason = 12;
   */
  cancelReason?: string;

  /**
   * @generated from field: optional string min_deposit_amount = 13;
   */
  minDepositAmount?: string;

  /**
   * @generated from field: bool is_active = 14;
   */
  isActive: boolean;

  /**
   * @generated from field: bool is_expired = 15;
   */
  isExpired: boolean;

  /**
   * @generated from field: common.BonusRulesMessage rules = 16;
   */
  rules?: BonusRulesMessage;

  /**
   * @generated from field: optional string will_burn = 17;
   */
  willBurn?: string;

  /**
   * @generated from field: optional string will_remain = 18;
   */
  willRemain?: string;

  /**
   * @generated from field: bool has_open_positions = 19;
   */
  hasOpenPositions: boolean;

  /**
   * @generated from field: optional string amount = 20;
   */
  amount?: string;

  /**
   * @generated from field: optional string deposit_amount = 21;
   */
  depositAmount?: string;

  /**
   * @generated from field: optional string available_profit = 22;
   */
  availableProfit?: string;
};

/**
 * Describes the message common.BonusMessage.
 * Use `create(BonusMessageSchema)` to create a new message.
 */
export const BonusMessageSchema: GenMessage<BonusMessage> = /*@__PURE__*/
  messageDesc(file_common_bonus, 1);

/**
 * @generated from message common.BonusHistoryMessage
 */
export type BonusHistoryMessage = Message<"common.BonusHistoryMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: common.BonusStatus status = 2;
   */
  status: BonusStatus;

  /**
   * @generated from field: optional string code = 3;
   */
  code?: string;

  /**
   * @generated from field: string amount = 4;
   */
  amount: string;

  /**
   * @generated from field: string current_turnover = 5;
   */
  currentTurnover: string;

  /**
   * @generated from field: string required_turnover = 6;
   */
  requiredTurnover: string;

  /**
   * @generated from field: string progress_percent = 7;
   */
  progressPercent: string;

  /**
   * @generated from field: optional string activated_at = 8;
   */
  activatedAt?: string;

  /**
   * @generated from field: optional string completed_at = 9;
   */
  completedAt?: string;

  /**
   * @generated from field: optional string cancel_reason = 10;
   */
  cancelReason?: string;

  /**
   * @generated from field: string transferred_amount = 11;
   */
  transferredAmount: string;

  /**
   * @generated from field: string burned_amount = 12;
   */
  burnedAmount: string;

  /**
   * @generated from field: optional common.BonusCalculationRule calc_rule = 13;
   */
  calcRule?: BonusCalculationRule;

  /**
   * @generated from field: optional string calc_value = 14;
   */
  calcValue?: string;
};

/**
 * Describes the message common.BonusHistoryMessage.
 * Use `create(BonusHistoryMessageSchema)` to create a new message.
 */
export const BonusHistoryMessageSchema: GenMessage<BonusHistoryMessage> = /*@__PURE__*/
  messageDesc(file_common_bonus, 2);

/**
 * @generated from message common.BonusCancelMessage
 */
export type BonusCancelMessage = Message<"common.BonusCancelMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: common.BonusStatus status = 2;
   */
  status: BonusStatus;

  /**
   * @generated from field: string burned_amount = 3;
   */
  burnedAmount: string;

  /**
   * @generated from field: optional string cancel_reason = 4;
   */
  cancelReason?: string;
};

/**
 * Describes the message common.BonusCancelMessage.
 * Use `create(BonusCancelMessageSchema)` to create a new message.
 */
export const BonusCancelMessageSchema: GenMessage<BonusCancelMessage> = /*@__PURE__*/
  messageDesc(file_common_bonus, 3);

/**
 * @generated from message common.PromoCodeMessage
 */
export type PromoCodeMessage = Message<"common.PromoCodeMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: common.BonusIssueRule issue_rule = 4;
   */
  issueRule: BonusIssueRule;

  /**
   * @generated from field: string min_amount = 5;
   */
  minAmount: string;

  /**
   * @generated from field: common.BonusCalculationRule calc_rule = 6;
   */
  calcRule: BonusCalculationRule;

  /**
   * @generated from field: optional string calc_value = 7;
   */
  calcValue?: string;

  /**
   * @generated from field: optional string calc_max_amount = 8;
   */
  calcMaxAmount?: string;

  /**
   * @generated from field: string wagering_multiplier = 9;
   */
  wageringMultiplier: string;

  /**
   * @generated from field: common.WageringScope wagering_scope = 10;
   */
  wageringScope: WageringScope;

  /**
   * @generated from field: optional string min_trade = 11;
   */
  minTrade?: string;

  /**
   * @generated from field: optional string max_trade = 12;
   */
  maxTrade?: string;

  /**
   * @generated from field: optional string max_win = 13;
   */
  maxWin?: string;

  /**
   * @generated from field: optional string start_at = 14;
   */
  startAt?: string;

  /**
   * @generated from field: optional string end_at = 15;
   */
  endAt?: string;

  /**
   * @generated from field: optional int32 expiration_period_seconds = 17;
   */
  expirationPeriodSeconds?: number;

  /**
   * @generated from field: optional int32 max_total_redemptions = 18;
   */
  maxTotalRedemptions?: number;

  /**
   * @generated from field: int32 max_user_redemptions = 19;
   */
  maxUserRedemptions: number;

  /**
   * @generated from field: int32 current_redemptions = 20;
   */
  currentRedemptions: number;

  /**
   * @generated from field: bool is_active = 21;
   */
  isActive: boolean;

  /**
   * @generated from field: repeated string bonus_ids = 23;
   */
  bonusIds: string[];

  /**
   * Код атрибуции Alanbase (first-touch). Если задан — постбеки идут на этот код вместо самого промокода.
   * Пример: LOSHARA100.affiliate_code = "LOSHARASTART" → депозит/RS атрибутируются на LOSHARASTART.
   *
   * @generated from field: optional string affiliate_code = 25;
   */
  affiliateCode?: string;

  /**
   * Multi Balance Funding settings (only PROPORTIONAL distribution is active for now).
   *
   * @generated from field: common.FundingPriority funding_priority = 27;
   */
  fundingPriority: FundingPriority;

  /**
   * @generated from field: common.ProfitDistribution profit_distribution = 28;
   */
  profitDistribution: ProfitDistribution;

  /**
   * @generated from field: common.LossDistribution loss_distribution = 29;
   */
  lossDistribution: LossDistribution;

  /**
   * @generated from field: bool is_public = 30;
   */
  isPublic: boolean;
};

/**
 * Describes the message common.PromoCodeMessage.
 * Use `create(PromoCodeMessageSchema)` to create a new message.
 */
export const PromoCodeMessageSchema: GenMessage<PromoCodeMessage> = /*@__PURE__*/
  messageDesc(file_common_bonus, 4);

/**
 * @generated from message common.PromoUsageMessage
 */
export type PromoUsageMessage = Message<"common.PromoUsageMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string activated_at = 2;
   */
  activatedAt?: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string code = 4;
   */
  code: string;

  /**
   * @generated from field: common.BonusStatus status = 5;
   */
  status: BonusStatus;

  /**
   * @generated from field: optional string cancel_reason = 6;
   */
  cancelReason?: string;
};

/**
 * Describes the message common.PromoUsageMessage.
 * Use `create(PromoUsageMessageSchema)` to create a new message.
 */
export const PromoUsageMessageSchema: GenMessage<PromoUsageMessage> = /*@__PURE__*/
  messageDesc(file_common_bonus, 5);

/**
 * @generated from enum common.BonusStatus
 */
export enum BonusStatus {
  /**
   * @generated from enum value: BONUS_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BONUS_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: BONUS_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: BONUS_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: BONUS_STATUS_LOST = 4;
   */
  LOST = 4,

  /**
   * @generated from enum value: BONUS_STATUS_EXPIRED = 5;
   */
  EXPIRED = 5,

  /**
   * @generated from enum value: BONUS_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,
}

/**
 * Describes the enum common.BonusStatus.
 */
export const BonusStatusSchema: GenEnum<BonusStatus> = /*@__PURE__*/
  enumDesc(file_common_bonus, 0);

/**
 * @generated from enum common.BonusSource
 */
export enum BonusSource {
  /**
   * @generated from enum value: BONUS_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BONUS_SOURCE_PROMO_CODE = 1;
   */
  PROMO_CODE = 1,

  /**
   * @generated from enum value: BONUS_SOURCE_MANUAL = 2;
   */
  MANUAL = 2,
}

/**
 * Describes the enum common.BonusSource.
 */
export const BonusSourceSchema: GenEnum<BonusSource> = /*@__PURE__*/
  enumDesc(file_common_bonus, 1);

/**
 * @generated from enum common.BonusCalculationRule
 */
export enum BonusCalculationRule {
  /**
   * @generated from enum value: BONUS_CALCULATION_RULE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BONUS_CALCULATION_RULE_FIXED = 1;
   */
  FIXED = 1,

  /**
   * @generated from enum value: BONUS_CALCULATION_RULE_PERCENTAGE = 2;
   */
  PERCENTAGE = 2,
}

/**
 * Describes the enum common.BonusCalculationRule.
 */
export const BonusCalculationRuleSchema: GenEnum<BonusCalculationRule> = /*@__PURE__*/
  enumDesc(file_common_bonus, 2);

/**
 * @generated from enum common.BonusIssueRule
 */
export enum BonusIssueRule {
  /**
   * @generated from enum value: BONUS_ISSUE_RULE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BONUS_ISSUE_RULE_ON_FIRST_DEPOSIT = 1;
   */
  ON_FIRST_DEPOSIT = 1,

  /**
   * @generated from enum value: BONUS_ISSUE_RULE_ON_EVERY_DEPOSIT = 2;
   */
  ON_EVERY_DEPOSIT = 2,
}

/**
 * Describes the enum common.BonusIssueRule.
 */
export const BonusIssueRuleSchema: GenEnum<BonusIssueRule> = /*@__PURE__*/
  enumDesc(file_common_bonus, 3);

/**
 * @generated from enum common.WageringScope
 */
export enum WageringScope {
  /**
   * @generated from enum value: WAGERING_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WAGERING_SCOPE_BONUS_ONLY = 1;
   */
  BONUS_ONLY = 1,

  /**
   * @generated from enum value: WAGERING_SCOPE_COMBINED = 2;
   */
  COMBINED = 2,
}

/**
 * Describes the enum common.WageringScope.
 */
export const WageringScopeSchema: GenEnum<WageringScope> = /*@__PURE__*/
  enumDesc(file_common_bonus, 4);

/**
 * Which balance funds a trade first under Multi Balance Funding.
 *
 * @generated from enum common.FundingPriority
 */
export enum FundingPriority {
  /**
   * @generated from enum value: FUNDING_PRIORITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * current default
   *
   * @generated from enum value: FUNDING_PRIORITY_BONUS_FIRST = 1;
   */
  BONUS_FIRST = 1,

  /**
   * requires WAGERING_SCOPE_COMBINED
   *
   * @generated from enum value: FUNDING_PRIORITY_REAL_FIRST = 2;
   */
  REAL_FIRST = 2,
}

/**
 * Describes the enum common.FundingPriority.
 */
export const FundingPrioritySchema: GenEnum<FundingPriority> = /*@__PURE__*/
  enumDesc(file_common_bonus, 5);

/**
 * How a winning trade's profit is split back across the funding balances.
 * Only PROPORTIONAL is active; the *_FIRST values are reserved for later.
 *
 * @generated from enum common.ProfitDistribution
 */
export enum ProfitDistribution {
  /**
   * @generated from enum value: PROFIT_DISTRIBUTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROFIT_DISTRIBUTION_PROPORTIONAL = 1;
   */
  PROPORTIONAL = 1,

  /**
   * @generated from enum value: PROFIT_DISTRIBUTION_TO_REAL_FIRST = 2;
   */
  TO_REAL_FIRST = 2,

  /**
   * @generated from enum value: PROFIT_DISTRIBUTION_TO_BONUS_FIRST = 3;
   */
  TO_BONUS_FIRST = 3,
}

/**
 * Describes the enum common.ProfitDistribution.
 */
export const ProfitDistributionSchema: GenEnum<ProfitDistribution> = /*@__PURE__*/
  enumDesc(file_common_bonus, 6);

/**
 * How a losing trade's loss is split across the funding balances.
 * Only PROPORTIONAL is active; the *_FIRST values are reserved for later.
 *
 * @generated from enum common.LossDistribution
 */
export enum LossDistribution {
  /**
   * @generated from enum value: LOSS_DISTRIBUTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOSS_DISTRIBUTION_PROPORTIONAL = 1;
   */
  PROPORTIONAL = 1,

  /**
   * @generated from enum value: LOSS_DISTRIBUTION_FROM_REAL_FIRST = 2;
   */
  FROM_REAL_FIRST = 2,

  /**
   * @generated from enum value: LOSS_DISTRIBUTION_FROM_BONUS_FIRST = 3;
   */
  FROM_BONUS_FIRST = 3,
}

/**
 * Describes the enum common.LossDistribution.
 */
export const LossDistributionSchema: GenEnum<LossDistribution> = /*@__PURE__*/
  enumDesc(file_common_bonus, 7);

